<template>
  <div class="sc-thanks-container">
    <h1 class="page-title"><b>{{ $t('thank_you.thank_you_header') }}</b></h1>
    <div class="sc-thanks-order-id-container-bank-payment">
      <div class="sc-thanks-order-label">
        {{ $t('thank_you.order_id') }}
      </div>
      <div class="sc-thanks-order-id">
        {{ orderId }}
      </div>
    </div>
    <sc-progress-steps :steps="steps" class="sc-thanks-progress-steps"/>
    <div>
      <div>
        <div class="sc-thanks-bolder-text">{{ $t('thank_you.bank_transfer_choosen') }}</div>
        <div class="sc-thanks-info">{{ $t('thank_you.please_transfer_money', { orderId }) }}</div>
        <!-- <div class="sc-thanks-info sc-thanks-appointment">{{ $t('thank_you.book_appointment') }}</div> -->
      </div>
      <sc-download-link :href="contractUrl" :text="$t('thank_you.download_contract')" class="sc-thanks-download-link"/>
      <sc-card class="sc-thanks-card">
        <div slot="content">
          <div class="sc-thanks-bank-data-container">
            <div class="sc-thanks-card-row">
              <div class="sc-thanks-card-first-row">
                {{ $t('thank_you.transferee') }}
              </div>
              <div>
                {{ transferTo }}
              </div>
            </div>
            <hr class="sc-thanks-bank-data-hr">
            <div class="sc-thanks-card-row">
              <div class="sc-thanks-card-first-row">
                {{ $t('thank_you.bank_name') }}
              </div>
              <div>
                {{ bankName }}
              </div>
            </div>
            <hr class="sc-thanks-bank-data-hr">
            <div class="sc-thanks-card-row">
              <div class="sc-thanks-card-first-row">
                {{ $t('thank_you.account_number') }}
              </div>
              <div>
                {{ bankAccountNumber }}
              </div>
            </div>
            <hr class="sc-thanks-bank-data-hr">
            <div class="sc-thanks-card-row">
              <div class="sc-thanks-card-first-row">
                {{ $t('thank_you.amount') }}
              </div>
              <div>
                {{ $price(total) }}
              </div>
            </div>
            <hr class="sc-thanks-bank-data-hr">
            <div class="sc-thanks-card-row">
              <div class="sc-thanks-card-first-row">
                {{ $t('thank_you.order_id') }}
              </div>
              <div>
                {{ orderId }}
              </div>
            </div>
          </div>
        </div>
      </sc-card>
      <div class="sc-thanks-main-page">
        <router-link :to="Routes.home()" class="no-text-decoration">
          <rounded-button color="outline" size="large">
              {{ $t('thank_you.main_page') }}
          </rounded-button>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { ScProgressSteps, ScDownloadLink, ScCard } from 'smartcommerce-component-library'
import thanksMixin from '../mixins/thanks.mixin'
import { Routes } from '../utils/Routes'
import RoundedButton from '../../shared/components/RoundedButton'

export default {
  name: 'ThanksWire',
  components: {
    ScProgressSteps, ScDownloadLink, ScCard, RoundedButton
  },

  mixins: [thanksMixin],

  created () {
    if (!this.checkLastOrderResponse()) {
      this.$router.push(Routes.PAYMENT)
      return
    }

    const PostOrderStepLabels = [
      'thank_you.step_price_arrived',
      'thank_you.step_register_vehicles',
      'thank_you.step_appointment_book',
      'thank_you.step_install_device'
    ]
    for (let i = 0; i < PostOrderStepLabels.length; i++) {
      let object = { text: this.$t(PostOrderStepLabels[i]), checked: false }
      this.steps.push(object)
    }

    this.$ga && this.$ga.event({
      eventCategory: 'Order or Purchase',
      eventAction: 'Successful',
      eventLabel: 'Wire',
      eventValue: this.total
    })
  },
  data () {
    return {
      steps: [],
      Routes
    }
  },

  computed: {
    transferTo () {
      return this.paymentInfo.wiretransfer ? this.paymentInfo.wiretransfer.to : null
    },

    bankName () {
      return this.paymentInfo.wiretransfer ? this.paymentInfo.wiretransfer.bank : null
    },

    bankAccountNumber () {
      return this.paymentInfo.wiretransfer ? this.paymentInfo.wiretransfer.accountNumber : null
    }
  }
}
</script>

<style scoped lang="scss">
.sc-thanks-container {
  margin: auto;
  width: 80%;
}
.sc-thanks-progress-steps {
  padding: 0px;
  height: 120px;
}
.sc-thanks-order-id-container-bank-payment {
  display: inline-flex;
  margin-bottom: 50px;
}
.sc-thanks-order-label {
  font-size: 18px;
  color: $sc-text-dark;
  margin-right: 5px;
}
.sc-thanks-order-id {
  font-size: 18px;
  font-weight: 600;
  color: $sc-text-dark;
}
.sc-thanks-bolder-text {
  text-align: left;
  font-size: 16px;
  font-weight: 600;
  color: $sc-text-dark;
  margin-bottom: 20px;
}
.sc-thanks-info {
  text-align: left;
  font-size: 16px;
  color: $sc-text-dark;
}
.sc-thanks-appointment {
  margin-top: 20px;
}
.sc-thanks-download-link {
  font-size: 16px;
  font-weight: 600;
  float: left;
  margin: 20px 0px 40px;
}
.sc-thanks-card-row {
  width: 100%;
  display: inline-flex;
}
.sc-thanks-card-first-row {
  width: 50%;
}
.sc-thanks-card {
  width: 100%;
  box-shadow: 0px 1px 1px 1px rgba(220,220,220, 0.4);
}
.sc-thanks-main-page {
  width: 200px;
  margin: 30px auto;
}
.sc-thanks-bank-data-container {
  color: $sc-text-dark;
  width: 75%;
}
.sc-thanks-bank-data-hr {
  margin: 10px 0px;
}

@media(max-width: 768px) {
  .page-title{
    margin: 15px 0px;
  }

  .sc-thanks-progress-steps{
    display: none;
  }

  .sc-thanks-bank-data-container{
    width: 100%;

    .sc-thanks-card-row{
      display: block;
    }

    .sc-thanks-card-first-row{
      width: 100%;
    }
  }

  .sc-thanks-main-page{
    width: 100%;

    button{
      width: 80%;
      min-width: inherit;
      margin: auto;
    }
  }
}
</style>
